import { render, staticRenderFns } from "./veStuEvaluationConfigShow.vue?vue&type=template&id=1dea8c1f&scoped=true"
import script from "./veStuEvaluationConfigShow.vue?vue&type=script&lang=js"
export * from "./veStuEvaluationConfigShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea8c1f",
  null
  
)

export default component.exports